import store from '../store/Store';
import type ServicesRequestStatus from '../store/schema/ServicesRequestStatus';

/**
 * Util to get get meetingTypes request status of the booking page from store.
 */
export default function getPbpSettingRequestStatus(): ServicesRequestStatus {
    return store.pbpPublishingSetting.getPbpSettingRequestStatus;
}
